<template>
  <CustomerLoader>
    <MMainLayout class="bg-background">
      <template #header><TheHeader v-if="showHeaderAndFooter" /></template>
      <template #content>
        <RouterView v-slot="{ Component }">
          <KeepAlive :include="keepAliveInclude">
            <BankingContextSwitchOverlay>
              <component :is="Component" />
            </BankingContextSwitchOverlay>
          </KeepAlive>
        </RouterView>
      </template>
      <template #footer><TheFooter v-if="showHeaderAndFooter" /></template>
    </MMainLayout>
  </CustomerLoader>

  <GlobalDialogService />
</template>

<script setup lang="ts">
import { RouterView, useRoute } from "vue-router";
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import BankingContextSwitchOverlay from "@/components/BankingContextSwitchOverlay.vue";
import { computed, onMounted } from "vue";
import { routeNames } from "@/router/constants";
import { MMainLayout, useTheme } from "@moroku/money-webapp-components";
import { envIsDemoLocalOrDev, featureEnabled } from "@/config";
import useAuthUser from "@/composables/useAuthUser";
import CustomerLoader from "@/components/CustomerLoader.vue";
import GlobalDialogService from "@/components/globalDialogService/GlobalDialogService.vue";
import { MoneyFeatures } from "@/config/constants";

const route = useRoute();
const { listenToThemeChanges, loadFavicon } = useTheme();

const { init: initAuth } = useAuthUser();
onMounted(() => {
  initAuth();
  loadFavicon();
});

const currentRouteName = computed((): string | null => {
  const name = route.name;
  if (typeof name === "string") return name;
  return null;
});

const keepAliveInclude = ["OnboardingView"];

const routesWithoutHeaderOrFooter = computed<string[]>(() => {
  if (featureEnabled(MoneyFeatures.Onboarding)) return [];

  return [
    routeNames.SIGN_IN_VIEW,
    routeNames.SIGN_UP_VIEW,
    routeNames.SIGN_IN_ERROR,
    routeNames.CUSTOMER_ERROR_VIEW,
    routeNames.REQUIRES_ONBOARDING_VIEW,
  ];
});

const showHeaderAndFooter = computed(() => {
  if (currentRouteName.value == null) return false;
  return !routesWithoutHeaderOrFooter.value.includes(currentRouteName.value!);
});

if (envIsDemoLocalOrDev) {
  listenToThemeChanges();
}
</script>

<style scoped></style>
